<h4 class="panel-title">Node Properties</h4>

<div class="panel-section z-order-buttons">
  <button class="z-order-btn" (click)="sendToBack.emit()" title="Send to Back">
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
      <rect x="8" y="8" width="13" height="13" rx="2" opacity="0.4" />
      <rect x="3" y="3" width="13" height="13" rx="2" fill="var(--ion-background-color, #fff)" />
    </svg>
    Back
  </button>
  <button class="z-order-btn" (click)="bringToFront.emit()" title="Bring to Front">
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
      <rect x="3" y="3" width="13" height="13" rx="2" opacity="0.4" />
      <rect x="8" y="8" width="13" height="13" rx="2" fill="var(--ion-background-color, #fff)" />
    </svg>
    Front
  </button>
</div>

<div class="panel-section">
  <dojo-text-input
    [label]="nodeData()['is_math'] ? 'LaTeX' : 'Text'"
    [formCtrl]="nodeTextCtrl()"
    size="s"
    (input)="textInput.emit()"
  />
  <div class="math-toggle">
    <label class="toggle-label">LaTeX mode</label>
    <ion-toggle [checked]="!!nodeData()['is_math']" (ionChange)="mathToggle.emit(ionToggleChecked($event))" />
  </div>
</div>

<div class="panel-section">
  <label class="field-label">Icon</label>
  <div class="icon-picker-row">
    @if (nodeData()['icon']) {
      <span class="current-icon" (click)="iconPickerToggle.emit(!showIconPicker())" title="Change icon">
        @switch (parsedNodeIcon()?.type) {
          @case ('emoji') {
            {{ parsedNodeIcon()?.value }}
          }
          @case ('fa') {
            <i [class]="'fas fa-' + parsedNodeIcon()?.value" [style.color]="parsedNodeIcon()?.color"></i>
          }
          @case ('img') {
            <img [src]="parsedNodeIcon()?.value" alt="" class="icon-preview-img" />
          }
        }
      </span>
      <button class="icon-clear-btn" (click)="iconCleared.emit()" title="Remove icon">&times;</button>
    }
    <button class="icon-pick-btn" (click)="iconPickerToggle.emit(!showIconPicker())">
      {{ showIconPicker() ? 'Close' : nodeData()['icon'] ? 'Change' : 'Add Icon' }}
    </button>
  </div>
  @if (showIconPicker()) {
    <div class="icon-picker-container">
      <dojo-icon-picker-wrapper
        [activeIconValue]="nodeData()['icon']?.toString()"
        (iconSelected)="iconSelected.emit($event)"
      />
    </div>
  }
</div>

<div class="panel-section">
  <dojo-single-select
    label="Shape"
    [formCtrl]="nodeShapeCtrl()"
    [options]="shapeOptions()"
    optionLabel="label"
    optionValue="value"
    size="s"
    (selectionChange)="nodeShapeChange.emit($event)"
  />
</div>

<div class="panel-section">
  <dojo-single-select
    label="Color Theme"
    [formCtrl]="nodeColorThemeCtrl()"
    [options]="colorThemeOptions()"
    optionLabel="label"
    optionValue="value"
    size="s"
    (selectionChange)="colorThemeChange.emit($event)"
  />
  <div class="color-preview">
    @for (opt of colorThemeOptions(); track opt.value) {
      <button
        class="color-swatch"
        [class.active]="nodeColorThemeCtrl().value === opt.value"
        [style.background]="getSwatchBg(opt.value)"
        [style.border-color]="getSwatchBorder(opt.value)"
        [style.color]="getSwatchText(opt.value)"
        [title]="opt.label"
        (click)="colorThemeChange.emit(opt.value)"
      >
        A
      </button>
    }
  </div>
</div>

<div class="panel-section border-toggle">
  <label class="toggle-label">Show Border</label>
  <ion-toggle [checked]="nodeData()['has_border'] === true" (ionChange)="borderToggle.emit(ionToggleChecked($event))" />
</div>

<div class="panel-section">
  <dojo-number-input
    label="Font Size"
    [formCtrl]="nodeFontSizeCtrl()"
    [min]="8"
    [max]="48"
    [step]="1"
    size="s"
    (input)="fontSizeChange.emit(nodeFontSizeCtrl().value)"
  />
</div>

<div class="panel-section">
  <dojo-single-select
    label="Font Weight"
    [formCtrl]="nodeFontWeightCtrl()"
    [options]="fontWeightOptions()"
    optionLabel="label"
    optionValue="value"
    size="s"
    (selectionChange)="fontWeightChange.emit($event)"
  />
</div>

<div class="panel-section size-inputs">
  <dojo-number-input
    label="Width"
    [formCtrl]="nodeWidthCtrl()"
    [min]="20"
    [max]="1000"
    [step]="10"
    size="s"
    (input)="sizeChange.emit()"
  />
  <dojo-number-input
    label="Height"
    [formCtrl]="nodeHeightCtrl()"
    [min]="20"
    [max]="1000"
    [step]="10"
    size="s"
    (input)="sizeChange.emit()"
  />
</div>
